<div>
  @switch (editorType) {
    @case (editorTypes.dated) {
      <span [ngClass]="{ deactivated: deactivated }">{{ definition.title }}</span>
      @if (!deactivated) {
        <div>
          @if (!configOption.id) {
            <span class="small alert alert-warning p-1 m-0">
              This configuration will become active upon 'Save'
            </span>
          }
          @if (configOption.id) {
            <span class="small alert alert-success p-1 m-0">
              Active since {{ configOption.startAt | date: 'MM/dd/yyyy' }}
            </span>
          }
        </div>
      }
      @if (deactivated) {
        <div>
          <span  class="small alert alert-secondary p-1 m-0">
            Active from {{ configOption.startAt | date: 'MM/dd/yyyy'}} to {{ configOption.endAt | date: 'MM/dd/yyyy'}}
          </span>
        </div>
      }
    }
    @case (editorTypes.suboptions) {
      {{ definition.title }}
      @if (suboptionTypeDescriptions[definition.suboptionType]) {
        <div class="small text-muted">
          by {{ suboptionTypeDescriptions[definition.suboptionType] }}
        </div>
      }
    }
    @default {
      {{ definition.title }}
    }
  }
</div>
